import { render, staticRenderFns } from "./changeNickname.vue?vue&type=template&id=ee5ab182"
import script from "./changeNickname.vue?vue&type=script&lang=js"
export * from "./changeNickname.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports